module.exports = __webpack_public_path__ + "static/media/Montserrat-Regular.4fff79a0.woff";